/* eslint-disable no-restricted-imports */
import "@gx1/gx-ui-common/styles/vars.css";
import { NavView } from "@gravity/tools";
import { FeatureFlagSessionStorageProvider } from "@gx1/gx-npm-feature-flags";
import { Fragment } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { MainNavAppV2ContextProvider } from "./app-v2.context";
import AppV3Component from "./app-v3.component";

export default function Root() {
  return (
    <FeatureFlagSessionStorageProvider apiUrl={`${window.gxApiConnection}/api/env`}>
      <MainNavAppV2ContextProvider>
        <BrowserRouter useTransitions={false}>
          <Routes>
            <Route path="/s/evaluation/:initiativeId/questionnaires/setup" element={<Fragment />} />
            <Route path="/s/evaluation/:initiativeId/questionnaires/:surveyId/setup" element={<Fragment />} />
            <Route path="/s/evaluation/:initiativeId/:tab/*" element={<AppV3Component view={NavView.WORKFLOW} />} />
            <Route path="/s/evaluation/:initiativeId" element={<AppV3Component view={NavView.WORKFLOW} />} />
            <Route path="*" element={<AppV3Component view={NavView.PRIMARY} />} />
          </Routes>
        </BrowserRouter>
      </MainNavAppV2ContextProvider>
    </FeatureFlagSessionStorageProvider>
  );
}
